import React, {useContext, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {useLocation, useNavigate} from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import {
    displacementOptions,
    orderStatusOptions,
    orderSubStatusOption,
    orderTypeOptions
} from "@/constants/selectOptions";
// import { useGetAllReservationQuery } from "@/redux/reservationApi";
// import { useGetClientNameListQuery } from "@/redux/clientApi";
import {dateFormatDateTime, dateFormatToISOString, useListPageFilter} from "@/utils";
import {Confirm, PageTabs, Pagination, Toast} from "@/components";
import Select from "react-select";
import {
    useGetAssignedOrderListMutation,
    useGetRequestedOrderListMutation,
    usePutOrderCancelMutation,
    usePutRequestCancelMutation,
} from "@/redux/orderApi";
import {rolesOptions} from "../../constants/selectOptions";

const pageFilter = {
    parameters: {
        reserveDateStart: null,
        reserveDateEnd: null,
        status: null,
        query: "",
        clientId: null,
        page: 0,
        size: 10,
        startedAt: "",
        endedAt: "",
        sort: [],
        tab: "1", // 탭 상태를 URL에 포함
    },
};

export const OrderAssignment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        assignmentCancelPopupStatus: false,
        triggerSearch: false,
    });
    const { confirmStatus, assignmentCancelPopupStatus, triggerSearch } = formData;

    const [getAssignedOrderList, { data: assignedData, error: assignedError, refetch: assignedRefetch }] = useGetAssignedOrderListMutation({
        skip: !triggerSearch,
    });
    const [getRequestedOrderList, { data: requestedData, error: requestedError, refetch: requestedRefetch }] =
        useGetRequestedOrderListMutation({ skip: !triggerSearch });

    // 탭 상태를 URL 파라미터와 동기화
    const currentTab = parseInt(parameters.tab) || 1;

    useEffect(() => {
        if (location.state?.currentTab) {
            setFormData((prev) => ({
                ...prev,
                parameters: { ...prev.parameters, tab: location.state.currentTab.toString() },
            }));
        }
    }, [location.state]);

    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "배정/요청 목록" },
                });
            }
        };

        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    useEffect(() => {
        if (triggerSearch) {
            if (currentTab === 1) {
                getAssignedOrderList({ params: parameters });
            }
            if (currentTab === 2) {
                getRequestedOrderList({ params: parameters });
            }
            setFormData((prev) => ({
                ...prev,
                triggerSearch: false,
            }));
        }
    }, [triggerSearch, currentTab, parameters.page]);

    // 페이지 변경 시 데이터 다시 조회
    useEffect(() => {
        if (parameters.page !== undefined) {
            if (currentTab === 1) {
                getAssignedOrderList({ params: parameters });
            }
            if (currentTab === 2) {
                getRequestedOrderList({ params: parameters });
            }
        }
    }, [parameters.page, currentTab, getAssignedOrderList, getRequestedOrderList]);

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);

    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    // 탭 변경 시 URL 파라미터 업데이트
    const handleTabChange = (tabValue) => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, tab: tabValue.toString(), page: 0 },
            triggerSearch: true,
        }));
    };

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, [name]: value },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;
        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }
        // setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));
        // setActiveButton(buttonIndex);
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">배정/요청 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>보험영업</li>
                                <li>배정/요청 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                <div className="toggle-list">
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === 1 ? "active" : ""}`}
                                        onClick={() => handleTabChange(1)}
                                    >
                                        배정 목록
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === 2 ? "active" : ""}`}
                                        onClick={() => handleTabChange(2)}
                                    >
                                        요청 목록
                                    </button>
                                </div>
                                <span className="data-count">
                                    {currentTab === 1 && assignedData?.pagination && (
                                        <>
                                            전체 <b>{assignedData.pagination.totalElements}</b>건
                                        </>
                                    )}
                                    {currentTab === 2 && requestedData?.pagination && (
                                        <>
                                            전체 <b>{requestedData.pagination.totalElements}</b>건
                                        </>
                                    )}
                                </span>
                            </div>
                            <div className="table-buttons"></div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                {currentTab === 1 && (
                                    <>
                                        <AssignmentListTable
                                            formData={formData}
                                            setFormData={setFormData}
                                            assignedList={assignedData}
                                            assignedRefetch={assignedRefetch}
                                        ></AssignmentListTable>
                                        {/* {assignedError && <p> 문제가 발생했습니다. </p>} */}
                                    </>
                                )}
                                {currentTab === 2 && (
                                    <>
                                        <RequestListTable
                                            formData={formData}
                                            setFormData={setFormData}
                                            requestList={requestedData}
                                            getRequestedOrderList={getRequestedOrderList}
                                        ></RequestListTable>
                                        {/* {requestedError && <p> 문제가 발생했습니다. </p>} */}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* {data?.data?.length ? <Pagination pagination={data?.pagination} setFormData={setFormData} /> : null} */}
                        {currentTab === 1 && assignedData?.data?.length > 0 && (
                            <Pagination pagination={assignedData?.pagination} setFormData={setFormData} />
                        )}
                        {currentTab === 2 && requestedData?.data?.length > 0 && (
                            <Pagination pagination={requestedData?.pagination} setFormData={setFormData} />
                        )}
                    </div>
                </div>
            </div>

            {assignmentCancelPopupStatus && (
                <AssignmentCancelPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, assignmentCancelPopupStatus: false, cancelOrderId: null }))}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    getAssignedOrderList={getAssignedOrderList}
                />
            )}

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;
        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }
        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));
        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select">
                            <Select
                                options={orderStatusOptions}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="차량상태"
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: { ...prev.parameters, order_status: option.value },
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: { ...pageFilter.parameters },
                                    }));
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RequestListTable = ({ formData, setFormData, requestList, getRequestedOrderList }) => {
    const navigate = useNavigate();
    const [putRequestCancel] = usePutRequestCancelMutation();

    return (
        <table>
            <colgroup>
                <col width="8%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="19%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="10%" />
            </colgroup>
            <thead>
                <tr>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">오더번호</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">구분</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">오더자 회원구분</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">지역</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">차량번호</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">차량정보</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">배기량</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">요청일시</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">배차일시</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">반납일시</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">보험사</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">청구율</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">상태</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">관리</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {requestList?.data && requestList?.data?.length === 0 ? (
                    <tr>
                        <td colSpan="12" className="data-empty">
                            <div className="cell" data-align="center">
                                <span className="cell-desc">데이터가 없습니다.</span>
                            </div>
                        </td>
                    </tr>
                ) : (
                    requestList?.data.map((item, index) => (
                        <tr key={`requestItem${index}`}>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{item.serialNumber}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-tag tag-box tag-green">
                                        {orderTypeOptions.find((e) => e.value === item.orderType)?.label}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">
                                        {item.orderMember?.roles
                                            ?.map((role) => rolesOptions.find((e) => e.value === role)?.label)
                                            .join(", ")}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{`${item.orderCustomer?.location1AddressCode?.name ?? ""} ${
                                        item.orderCustomer?.location2AddressCode?.name ?? ""
                                    }`}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{item.carNumber}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="left">
                                    <span className="cell-desc">{`${item.modelName || ""} ${item.modelDetailName || ""} ${
                                        item.className || ""
                                    } ${item.trimName || ""} `}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    {(() => {
                                        const status = displacementOptions.find((e) => e.value === item?.displacement);
                                        return <span className={`cell-desc`}>{status?.label}</span>;
                                    })()}{" "}
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{dateFormatDateTime(item.createdAt)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{dateFormatDateTime(item.releasedAt)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{dateFormatDateTime(item.returnedAt)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{`${item.orderInsurance?.insuranceCorpName ?? ""} ${
                                        item.orderInsurance?.receiptNumber ?? ""
                                    }`}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">
                                        {item?.orderInsurance?.chargeRate ? (item?.orderInsurance?.chargeRate || "0") + "%" : "-"}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    {(() => {
                                        const status = orderSubStatusOption.find((e) => e.value === item?.orderSubStatus);
                                        return <span className={`cell-tag ${status?.txtColor || ""}`}>{status?.label}</span>;
                                    })()}
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span
                                        className="btn-cell btn-outline"
                                        onClick={() => {
                                            navigate(`/order/detail/${item.id}`);
                                        }}
                                    >
                                        상세보기
                                    </span>
                                    <span
                                        className="btn-cell btn-cancel"
                                        onClick={() => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                confirmStatus: {
                                                    confirmPopupStatus: true,
                                                    confirmTitle: "요청취소",
                                                    confirmDescription: "요청을 취소하시겠습니까?",
                                                    confirmButtons: [
                                                        {
                                                            label: "예",
                                                            className: "btn-primary",
                                                            onClick: async () => {
                                                                try {
                                                                    await putRequestCancel({ orderId: item.id }).unwrap();
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        toastMsg: "요청이 취소되었습니다.",
                                                                    }));
                                                                    await getRequestedOrderList({});
                                                                } catch (error) {
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        toastMsg: error?.message || "요청취소에 실패하였습니다.",
                                                                    }));
                                                                }
                                                                // Confirm 팝업 닫기
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    confirmStatus: { confirmPopupStatus: false },
                                                                }));
                                                            },
                                                        },
                                                        {
                                                            label: "아니오",
                                                            className: "btn-cancel",
                                                            onClick: () =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    confirmStatus: { confirmPopupStatus: false },
                                                                })),
                                                        },
                                                    ],
                                                },
                                            }));
                                        }}
                                    >
                                        요청취소
                                    </span>
                                </div>
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );
};

const AssignmentListTable = ({ formData, setFormData, assignedList, assignedRefetch }) => {
    const navigate = useNavigate();


    const isAvailableRegisterContract = (item) => {
      return item.orderSubStatus === "SELECTED" || item.orderSubStatus === "CUSTOMER_CHECK" || item.orderSubStatus === "CUSTOMER_CHECK";
    }

    return (
        <table>
            <colgroup>
                <col width="8%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="19%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="7%" />
                <col width="10%" />
            </colgroup>
            <thead>
                <tr>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">오더번호</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">구분</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">오더자 회원구분</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">지역</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">차량번호</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">차량정보</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">배기량</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">대여차량</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">배차일시</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">반납일시</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">보험사</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">청구율</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">상태</span>
                        </div>
                    </th>
                    <th>
                        <div className="cell">
                            <span className="cell-tit">관리</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {assignedList?.data && assignedList?.data?.length === 0 ? (
                    <tr>
                        <td colSpan="12" className="data-empty">
                            <div className="cell" data-align="center">
                                <span className="cell-desc">데이터가 없습니다.</span>
                            </div>
                        </td>
                    </tr>
                ) : (
                    assignedList?.data.map((item, index) => (
                        <tr key={`assignedItem${index}`}>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{item.serialNumber}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-tag tag-box tag-green">
                                        {orderTypeOptions.find((e) => e.value === item.orderType)?.label}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">
                                        {item.orderMember?.roles
                                            ?.map((role) => rolesOptions.find((e) => e.value === role)?.label)
                                            .join(", ")}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{`${item.orderCustomer?.location1AddressCode?.name ?? ""} ${
                                        item.orderCustomer?.location2AddressCode?.name ?? ""
                                    }`}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{item.carNumber}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="left">
                                    <span className="cell-desc">
                                        {`${item.modelName ?? ""} ${item.modelDetailName ?? ""} ${item.className || ""} ${
                                            item.trimName || ""
                                        }`}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    {(() => {
                                        const status = displacementOptions.find((e) => e.value === item?.displacement);
                                        return <span className={`cell-desc`}>{status?.label}</span>;
                                    })()}{" "}
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{item?.contractCar?.carNumber || ""}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{dateFormatDateTime(item.releasedAt)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{dateFormatDateTime(item.returnedAt)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">{`${item.orderInsurance?.insuranceCorpName ?? ""} ${
                                        item.orderInsurance?.receiptNumber ?? ""
                                    }`}</span>
                                </div>
                            </td>

                            <td>
                                <div className="cell" data-align="center">
                                    <span className="cell-desc">
                                        {item?.orderInsurance?.chargeRate ? (item?.orderInsurance?.chargeRate || "0") + "%" : "-"}
                                    </span>
                                </div>
                            </td>

                            <td>
                                <div className="cell" data-align="center">
                                    {(() => {
                                        const status = orderSubStatusOption.find((e) => e.value === item?.orderSubStatus);
                                        return <span className={`cell-tag ${status?.txtColor || ""}`}>{status?.label}</span>;
                                    })()}
                                </div>
                            </td>
                            <td>
                                <div className="cell" data-align="center">
                                    <span
                                        className="btn-cell btn-outline"
                                        onClick={() => {
                                            navigate(`/order/detail/${item.id}`);
                                        }}
                                    >
                                        상세보기
                                    </span>
                                    {
                                        isAvailableRegisterContract(item) && (
                                            <span
                                                className="btn-cell btn-fourth"
                                                onClick={() => {
                                                    navigate("/contract/register", {
                                                        state: {
                                                            orderId: item.id,
                                                            order: item
                                                        }
                                                    });
                                                }}
                                            >
                                        계약서 등록
                                    </span>
                                        )
                                    }

                                    {/* <span
                                        className="btn-cell btn-cancel"
                                        onClick={() => {
                                            console.log(item.id);
                                            setFormData((prev) => ({
                                                ...prev,
                                                cancelOrderId: item.id,
                                                assignmentCancelPopupStatus: true,
                                            }));
                                        }}
                                    >
                                        배정취소
                                    </span> */}
                                </div>
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );
};

export const AssignmentCancelPopup = ({ layer = true, onClose, formData, setFormData, getAssignedOrderList }) => {
    const { cancelOrderId: orderId } = formData;
    const [cancelReason, setCancelReason] = useState("");
    const [orderReUploadYn, setOrderReUploadYn] = useState("Y");

    const [putOrderCancel] = usePutOrderCancelMutation();

    const handleSubmit = async () => {
        if (!cancelReason) {
            setFormData((prev) => ({ ...prev, toastMsg: "취소 사유를 작성해주세요." }));
            return;
        }
        try {
            const content = {
                cancelReason,
                orderReUploadYn,
            };
            await putOrderCancel({ orderId, content }).unwrap();
            setFormData((prev) => ({
                ...prev,
                toastMsg: "배차가 취소되었습니다.",
            }));
            onClose();
            await getAssignedOrderList({});
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "배차 취소에 실패하였습니다.",
            }));
        }
    };

    return ReactDOM.createPortal(
        <div className="popup-container">
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>
            <div className="popup memo-popup">
                <div className="popup-content">
                    <div className="memo-content">
                        <div className="content-input">
                            <textarea
                                placeholder="취소 사유를 작성해주세요."
                                value={cancelReason}
                                onChange={(e) => setCancelReason(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    {/* <div className="memo-check">
                        <div className="radiobox">
                            <input
                                type="radio"
                                name="orderReUploadYn"
                                id="orderReUploadYn_Y"
                                checked={orderReUploadYn === "Y"}
                                onChange={(e) => {
                                    setOrderReUploadYn("Y");
                                }}
                            />
                            <label htmlFor="orderReUploadYn_Y">오더 재등록</label>
                        </div>
                        <div className="radiobox">
                            <input
                                type="radio"
                                name="orderReUploadYn"
                                id="orderReUploadYn_N"
                                checked={orderReUploadYn === "N"}
                                onChange={(e) => {
                                    setOrderReUploadYn("N");
                                }}
                            />
                            <label htmlFor="orderReUploadYn_N">오더 재등록 안함</label>
                        </div>
                    </div> */}
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        완료
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};
